'use client';

import {styled} from "@mui/system";
import {Tooltip, tooltipClasses, TooltipProps} from "@mui/material";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.custom?.bgTooltip,
        color: theme.palette.background.default,
        maxWidth: 220,
    },
}));

export default HtmlTooltip;
